export const setJobTaxMessage = "Set a tax rate for this job to mark line items as taxable";
export const setTemplateTaxMessage =
    "Set a tax rate for this template to mark line items as taxable";

/**
 * Tax cell / line-item tooltip copy. Templates have no job, so they get
 * "this template"; everything else (jobs, change orders, budget, selections,
 * lead proposals) keeps "this job".
 */
export function getSetTaxMessage(isTemplate: boolean): string {
    return isTemplate ? setTemplateTaxMessage : setJobTaxMessage;
}

export enum TaxMethod {
    // For US builders this value is being used as "Non-Taxable"
    None = 0,
    // For US builders this value is being used as "Taxable"
    Exclusive = 1,
    Inclusive = 2,
}

export enum CompoundCalculationType {
    TaxOnly = 0,
    NetPlusTax = 1,
}

export const IntermediateRoundingScale = 10;

export interface ITaxGroupBreakdownItemRequest {
    title: string;
    compoundCalculationType?: CompoundCalculationType;
    totalEffectiveRate: number;
    taxRates: ITaxRateBreakdownItemRequest[];

    amount: number;
}

export interface ITaxRateBreakdownItemRequest {
    taxRateId: number;
    taxRateName: string;
    taxRatePercent: number;
    isActive: boolean;
    isCompoundRate: boolean;
}

export enum TaxesSetupActiveTab {
    TaxRate = "1",
    TaxGroup = "2",
}

export const CostCodeTaxableKey = "taxable";

export interface ITaxGroup {
    taxGroupId: number;
    taxGroupName: string;
    totalEffectiveRate: number;
    taxRates: ITaxRate[];
}

export interface ITaxRate {
    taxRateId: number;
    taxRateName: string;
    taxRatePercent: number;
}

export enum JobTaxVersion {
    None = 0,
    V1 = 1,
}
